import { mapState, mapGetters } from 'vuex';
import { allProducts } from '@/utils/products';

export default {
  computed: {
    ...mapState({
      productCodeState: (state) => state.quote.productCode,
      termState: (state) => state.quote.productTerms,
    }),
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
      authenticatedUser: 'auth/authenticatedUser',
    }),
    currentProduct() {
      return allProducts().find((product) => product.productCode === this.productCodeState);
    },
    currentUser() {
      return this.authenticatedUser;
    },
    userFullName() {
      return this.authenticatedUser?.userFullName || '';
    },
    userEmail() {
      return this.authenticatedUser?.userEmail || '';
    },
    agentCode() {
      return this.authenticatedUser?.agentCode || 0;
    },
    agentId() {
      return this.authenticatedUser?.agentId || '';
    },
    agentName() {
      return this.authenticatedUser?.agentName || '';
    },
    userRoles() {
      return this.authenticatedUser?.roles || [];
    },
    userId() {
      return this.authenticatedUser?.userId || null;
    },
    username() {
      return this.authenticatedUser?.username || '';
    },
  },
  methods: {
    hasRole(role) {
      return this.userRoles.includes(role);
    },
    isAdmin() {
      return this.hasRole('ADMIN') || this.hasRole('ADMINISTRATOR') || this.hasRole('STAFF');
    },
    isAgent() {
      return this.hasRole('AGENT');
    },
    canAccessAdminFeatures() {
      return this.isAdmin();
    },
    getUserInitials() {
      if (!this.userFullName) return '';
      return this.userFullName
        .split(' ')
        .map((name) => name.charAt(0).toUpperCase())
        .join('');
    },
    formatUserInfo() {
      return {
        id: this.userId,
        name: this.userFullName,
        email: this.userEmail,
        username: this.username,
        agentCode: this.agentCode,
        agentId: this.agentId,
        agentName: this.agentName,
        roles: this.userRoles,
      };
    },
  },
};
